<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Edit The Business Basic Info Form"
      id="owner_view_basic_info_edit_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="edit_basic_info_form_ref"
      id="edit_basic_info_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <br />
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.name"
            :validation_rules="form_validations.name"
            label="Name Of Business"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <ImageField
            label="Business Logo"
            icon="mdi-camera"
            :disabled="is_loading"
            folder="businesslogoes"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="edit_logo_file_uploader"
            :required="false"
            empty_file_error="No logo image choosen for the logo"
            :default_value="default_thumbnail"
          >
          </ImageField>
        </v-col>
      </v-row>

      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.tag_line"
            :validation_rules="form_validations.tag_line"
            label="Tag Line (e.g Our customer is our priority)"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.is_local_company"
            :options="local_companies_options"
            :small_chips="false"
            :validation_rules="form_validations.is_local_company"
            label="Company Origin"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <SelectField
            v-model="form.is_main_branch"
            :options="branch_types"
            :small_chips="false"
            :validation_rules="form_validations.is_main_branch"
            label="Branch Type"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
            @change="set_branch"
          ></SelectField>
        </v-col>
        <v-col>
          <SelectField
            v-model="form.is_branch_of_id"
            :options="my_companies"
            :small_chips="false"
            :validation_rules="form_validations.is_branch_of_id"
            label="Choose Main Branch"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>

      <TextArea
        v-model="form.description"
        :validation_rules="form_validations.description"
        label="Business Description"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextArea>

      <CardedSectionHeader
        icon="mdi-form-select"
        label="Sub Categories & Categories"
        id="owner_edit_business_subcategory_info_details"
      ></CardedSectionHeader>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col cols="4" no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="category_id"
            :options="categories"
            :small_chips="false"
            :validation_rules="form_validations.category_id"
            label="Category"
            icon="mdi-pen-plus"
            :disabled="disable_category_inputs"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col cols="4" no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="sub_category_id"
            :options="sub_categories"
            :small_chips="false"
            :validation_rules="form_validations.sub_category_id"
            label="Sub Category"
            icon="mdi-pen-plus"
            :disabled="disable_category_inputs"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col cols="2" no-gutters class="pb-0 pt-0 mb-0">
          <v-btn
            class="ma-1 mobile-app-bar-btn mt-2"
            dense
            rounded
            outlined
            color="success"
            @click="add_category_to_cart"
            :disabled="disable_category_inputs"
          >
            <v-icon left class="success--text">mdi-plus</v-icon> Add Category
          </v-btn>
        </v-col>
      </v-row>
      <div class="mb-5">
        <CardedTable
          :has_margin="false"
          :show_search="false"
          :height="200"
          :show_header_bar="false"
          :items="selected_categories"
          :headers="selected_categories_headers"
          :show_footer="false"
        >
          <template v-slot:[`item.icon`]="{ item }">
            <v-icon>{{ item.icon }}</v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              @click="on_remove_selected_sub_category_item(item)"
              x-small
              rounded
              text
              color="red"
            >
              <v-icon>mdi-cross</v-icon>
            </v-btn>
          </template>
        </CardedTable>
      </div>
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import TextArea from "../../../components/TextArea";
import ImageField from "../../../components/ImageField";
import SelectField from "../../../components/SelectField";
import CardedTable from "../../../components/CardedTable";
export default {
  name: "OwnerBusinessesEditInfo",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    TextField,
    ImageField,
    SelectField,
    TextArea,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      form: {
        name: "",
        tag_line: "",
        is_local_company: 0,
        is_main_branch: 0,
        description: "",
        is_branch_of_id: 0,
      },
      form_validations: {
        name: [
          Utils.validate.is_required("Business name is required"),
          Utils.validate.min_max_length(
            3,
            50,
            "Business name should be between 3 and 50 characters "
          ),
        ],
        tag_line: [
          Utils.validate.max_length(
            150,
            "Tag line should be less than 150 characters"
          ),
        ],
        is_local_company: [],
        is_main_branch: [],
        description: [
          Utils.validate.max_length(
            400,
            "Your business description should be less than 400 characters"
          ),
        ],
        category_id: [],
        sub_category_id: [],
        is_branch_of_id: [],
      },
      default_thumbnail: Utils.default_business_logo,
      categories: [],
      selected_categories: [],
      category_id: null,
      sub_category_id: null,
      is_processing_categories: false,
      selected_categories_headers: [
        { text: "", value: "icon" },
        { text: "Category", value: "category.name" },
        { text: "Sub Category", value: "name" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      my_companies: [],
      districts: [],
      branch_types: [
        { id: 0, name: "No Branch" },
        { id: 1, name: "Main Branch" },
        { id: 2, name: "Is Sub Branch" },
      ],
      local_companies_options: [
        { id: 1, name: "Local Company" },
        { id: 0, name: "Foreign Company" },
      ],
      thumb_nail: ""
    };
  },
  methods: {
    get_edit_business_dependencies(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_register_business_dependencies(
        {
          user_id: this.owner ? this.owner.id : this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.categories = res.categories;
          if (this.categories.length > 0) {
            this.category_id = this.categories[0].id;
            if (this.categories[0].sub_categories.length > 0) {
              this.sub_category_id = this.categories[0].sub_categories[0].id;
            }
          }
          this.my_companies = [
            {
              id: 0,
              name: "Self",
            },
          ].concat(res.businesses);
          this.load_business(id);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.edit_basic_info_form_ref.show_error_dialog();
        }
      );
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_basic_info_form_ref.show_error_dialog();
        }
      );
    },
    on_auto_fill() {
      this.init_form();
    },
    init_form() {
      this.form.name = this.business.name;
      this.default_thumbnail = this.business.logo;
      this.form.tag_line = this.business.tag_line;
      this.form.is_local_company = parseInt(this.business.is_local_company);
      this.form.is_main_branch = parseInt(this.business.is_main_branch);
      this.form.is_branch_of_id = parseInt(this.business.is_branch_of_id);
      this.form.description = this.business.description;
      this.thumb_nail = this.business.logo;
      //business categories
      var cats = [];
      for (var index = 0; index < this.business.belongings.length; index++) {
        var belonging = this.business.belongings[index];
        cats.push({
          ...belonging.sub_category,
          category: belonging.category,
        });
      }
      this.selected_categories = cats;
      this.errors = [];
      this.message = "";
    },
    submit() {
      //upload the logo
      this.$refs.edit_logo_file_uploader.upload_file();
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_finished_file_upload(file_url) {
      this.thumb_nail = file_url;
      this.update_business();
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.owner_view_basic_info_edit_form.show_error_dialog();
    },
    on_hide_message() {
        this.load_business(this.business_id);
    },
    set_branch(values) {
      if (parseInt(values.new_value) == 1) {
        this.form.is_branch_of_id = 0;
        return;
      }
      if (this.my_companies.length > 1) {
        //choose the first company
        this.form.is_branch_of_id = this.my_companies[1].id;
      } else {
        this.form.is_branch_of_id = -1;
      }
    },
    add_category_to_cart() {
      this.errors = [];
      this.is_processing_categories = true;
      if (this.category_id == null || parseInt(this.category_id == 0)) {
        this.errors.push("Please select a category for the business");
      }
      if (this.sub_category_id == null || parseInt(this.sub_category_id == 0)) {
        this.errors.push("Please select a sub category for the business");
      }
      //make sure that the sub category is not selected twice
      for (var index2 = 0; index2 < this.selected_categories.length; index2++) {
        var selected_sub_category = this.selected_categories[index2];
        if (
          parseInt(this.sub_category_id) == parseInt(selected_sub_category.id)
        ) {
          this.errors.push(
            "Sub Category, " +
              selected_sub_category.name +
              " is already selected"
          );
        }
      }
      //nyd
      //whats the limit, please find out from the project manager (Lorato)
      if (this.selected_categories.length == Utils.sub_categories_limit) {
        this.errors.push(
          "You cannot select more than " +
            Utils.sub_categories_limit +
            " sub categories fo your business"
        );
      }
      if (this.errors.length > 0) {
        this.is_processing_categories = false;
        this.$refs.edit_basic_info_form_ref.show_error_dialog();
        return false;
      }

      for (var index = 0; index < this.sub_categories.length; index++) {
        var sub_category = this.sub_categories[index];
        if (parseInt(this.sub_category_id) == parseInt(sub_category.id)) {
          var category = null;
          for (
            var cat_index = 0;
            cat_index < this.categories.length;
            cat_index++
          ) {
            var cat_temp = this.categories[cat_index];
            if (parseInt(this.category_id) == parseInt(cat_temp.id)) {
              category = cat_temp;
              break;
            }
          }
          this.selected_categories.push({
            ...sub_category,
            category: category,
          });
        }
      }

      //nyd
      //improve this cart so that the sub category that is already seleceted is emoved from
      //the drop down, and when a category has no more sub sub cateories it is removed from
      //the drop down, when a user removed a selected sub category then its added back to the
      //drop down and also the category is added back if it was not there in the drop down;

      this.is_processing_categories = false;
      this.sub_category_id = null;
    },
    on_remove_selected_sub_category_item(selected_sub_category) {
      var temp = [];
      for (var index = 0; index < this.selected_categories.length; index++) {
        var selected_category = this.selected_categories[index];
        if (
          parseInt(selected_category.id) == parseInt(selected_sub_category.id)
        ) {
          console.log("his Arthur ", selected_category);
          continue; //skip this one
        }
        temp.push(selected_category);
      }
      this.selected_categories = temp;
    },
    update_business() {
      this.errors = [];
      this.message = "";

      //sub branch cannot be 0 if
      //one choose self for branch type
      if (
        parseInt(this.form.is_main_branch) == 2 &&
        parseInt(this.form.is_branch_of_id) <= 0
      ) {
        this.errors.push(
          "Please select another company as the parent branch of this company"
        );
        this.$refs.edit_basic_info_form_ref.show_error_dialog();
        return;
      }

      //there should be atleast one category selected
      //for the business
      if (this.selected_categories.length == 0) {
        this.errors.push(
          "Please select atleast one sub category that your business belongs to"
        );
        this.$refs.edit_basic_info_form_ref.show_error_dialog();
        return;
      }
  
      ServerClient.Businesses.update_my_business(
        {
          data: {
              ... this.form,
              logo: this.thumb_nail
          },
          categories: this.selected_categories,
          is_added_by_admin: this.owner != null,
          id: this.business_id
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_basic_info_form_ref.on_clear_form();
          this.message =
            "<b>Operation was successfull</b> <br/>  Your Business information was updated successfully";
          this.$refs.edit_basic_info_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.edit_basic_info_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
       

    },
  },
  computed: {
    disable_category_inputs() {
      if (this.is_loading || this.is_processing_categories) {
        return true;
      }
      return false;
    },
    sub_categories() {
      var temp = [];
      for (var index = 0; index < this.categories.length; index++) {
        var cat = this.categories[index];
        if (parseInt(cat.id) == parseInt(this.category_id)) {
          temp = cat.sub_categories;
          break;
        }
      }
      return temp;
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Manage Basic Info",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Edit",
          disabled: true,
          href:
            "/owner/businesses/list/view/" + this.business_id + "/edit_info",
        },
      ],
      navbar_cols: 3,
    });
    this.get_edit_business_dependencies(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_basic_info_edit_form", options);
  },
};
</script>